import { Navigate, useLocation } from 'react-router-dom';
import { useGymAdmin } from '../context/gym-admin-context';

/**
 * Where the by-block table used to live. It is a way of reading one round, not
 * a page of its own, so it moved onto the round's board behind the
 * Athlete/Block switch — and links to the old one are out in the world, in a
 * browser's history and in messages to the desk, so they are moved rather than
 * broken.
 *
 * **What the old address said travels with it.** `?round=` named the round,
 * which is now the path itself; the open class comes across as it was, and the
 * view is pinned to the one the link was asking for. An old address that names
 * no round has nothing to point at, so it lands on the rounds entry, which
 * opens the first one.
 */
export default function RoundBlocksRedirect() {
  const { search } = useLocation();
  const { placePath } = useGymAdmin();

  const params = new URLSearchParams(search);
  const round = params.get('round');
  params.delete('round');
  params.set('view', 'blocks');

  if (!round) return <Navigate to={placePath('/rounds')} replace />;

  return <Navigate to={`${placePath(`/rounds/${round}`)}?${params}`} replace />;
}
